export default "__VITE_ASSET__791f0d8f__"